import { Directive, inject } from '@angular/core';

import { ResourceConfig } from '../../models/core/resource.config';
import { RequestService } from '../../services/request.service';

/**
 * Resources default class.
 */
@Directive()
export abstract class BaseResource {
    /**
     * Resource configuration.
     */
    protected _config: ResourceConfig;

    /**
     * Whether it's static (uses local data).
     */
    protected _isStatic = false;

    /**
     * Whether the URL is absolute (external server).
     */
    protected _isAbsoluteUrl = false;

    protected readonly _requestService = inject(RequestService);

    // eslint-disable-next-line @angular-eslint/prefer-inject
    protected constructor(config: ResourceConfig) {
        this._isAbsoluteUrl = this.isUrlAbsolute(config.baseController);
        this._config = config;
    }

    /**
     * Retrieves a URL with the base controller.
     * @param action Action.
     */
    protected getUrl(action: string): string {
        return `${this._config.baseController}${action ? `/${action}` : ''}`;
    }

    /**
     * Checks whether the URL is absolute or not.
     * URLs starting with "[protocol]://" will be considered absolute.
     *  - Accepted protocols: http, https, ftp, ftps
     * @param url URL.
     */
    private isUrlAbsolute(url: string): boolean {
        if (!url) {
            return false;
        }

        return /^(f|ht)tps?:/i.test(url);
    }
}
